<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>安全中心</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-box">
            <div class="detail-item">
                <div class="item-title">
                    账户安全
                </div>
                <div class="safe-item__wrapper">
                    <div class="safe-item__box">
                        <div class="icon checked">
                            <v-svg-icon
                                name="icon-baohu"
                            />
                        </div>
                        <div class="title">
                            登录密码
                        </div>
                        <div class="desc">
                            可对登录密码进行修改操作，定时修改可保障帐户安全
                        </div>
                        <div class="status">
                            已设置
                        </div>
                        <div class="handler">
                            <el-button
                                size="small"
                                type="text"
                                @click="goPage('/index/info/password')"
                            >
                                修改
                            </el-button>
                        </div>
                    </div>
                    <div class="safe-item__box">
                        <div class="icon checked">
                            <v-svg-icon
                                name="icon-baohu"
                            />
                        </div>
                        <div class="title">
                            手机绑定
                        </div>
                        <div class="desc">
                            手机绑定后，在您的账号发生重要变更时，通过短信告知您。
                        </div>
                        <div class="status">
                            已设置
                        </div>
                        <div class="handler">
                            <el-button
                                size="small"
                                type="text"
                                @click="goPage('/index/info/phone')"
                            >
                                修改
                            </el-button>
                        </div>
                    </div>
                    <div class="safe-item__box">
                        <div class="icon checked">
                            <v-svg-icon
                                name="icon-baohu"
                            />
                        </div>
                        <div class="title">
                            邮箱绑定
                        </div>
                        <div class="desc">
                            邮箱绑定后，在您的账号发生重要变更时，通过邮件通知您。
                        </div>
                        <div class="status">
                            已设置
                        </div>
                        <div class="handler">
                            <el-button
                                size="small"
                                type="text"
                                @click="goPage('/index/info/mail')"
                            >
                                修改
                            </el-button>
                        </div>
                    </div>
                    <div class="safe-item__box" v-if="info.role_id !== 2">
                        <div :class="(payPWD ? 'checked ' : '') + 'icon'">
                            <v-svg-icon
                                name="icon-baohu"
                            />
                        </div>
                        <div class="title">
                            支付密码
                        </div>
                        <div class="desc">
                            在结算时，需要输入的密码
                        </div>
                        <div :class="(payPWD === 1 ? '' : 'text-danger ') + 'status'">
                            {{ statusList[payPWD] || '未设置'}}
                        </div>
                        <div class="handler">
                            <el-button
                                v-if="payPWD"
                                size="small"
                                type="text"
                                @click="goPage('/index/info/paypassword')"
                            >
                                修改
                            </el-button>
                            <el-button
                                v-else
                                size="small"
                                type="text"
                                @click="goPage('/index/info/paypassword')"
                            >
                                设置
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Safe',
    inject: ['goPage'],
    data () {
        return {
            statusList: ['未设置', '已设置'],
            info: {},
            phone: '',
            payPWD: -1
        }
    },
    mounted () {
        this.updateProfile()
    },
    methods: {
        updateProfile () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                        localStorage.setItem('USERINFO', JSON.stringify(res.data))
                        this.getPhone()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getPhone () {
            let phone = JSON.parse(localStorage.getItem('USERINFO')).phone + ''
            this.payPWD = JSON.parse(localStorage.getItem('USERINFO')).is_pay_pwd
            this.phone = phone.substring(3, 0) + ' **** ' + phone.substr(-4)
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";
</style>
